import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import { isPetResident } from "utils/application.utils";
import { getResidentsCount, getTotalIncome } from "../DragItem/dragItem.utils";

/**
 * Everything the candidate list and the other-applications dialog read off an
 * application to render its indicators, derived in one place so the two cannot
 * arrive at different numbers for the same record (DEV-3122).
 *
 * Required comes from the row and is never derived here; only delivered is
 * counted, because the document arrays are truthful (DEV-3135).
 */
export const getApplicationIndicators = (application: IApplication) => {
  const contacts = application.contacts ?? [];
  const residents = application.residents ?? [];
  const declaredIncomes = contacts.flatMap(contact => contact.income || []);

  return {
    totalIncome: getTotalIncome(contacts),
    adultCount: getResidentsCount(residents, "INTAKE_RESIDENT_ADULTS"),
    childrenCount: getResidentsCount(residents, "INTAKE_RESIDENT_CHILDREN"),
    petCount: residents.reduce(
      (count, resident) =>
        isPetResident(resident.id) ? count + resident.value : count,
      0,
    ),
    idDocs: {
      required: application.requiredIdDocuments,
      delivered: contacts.filter(
        contact => (contact.documents?.length ?? 0) > 0,
      ).length,
    },
    incomeDocs: {
      required: application.requiredIncomeDocuments,
      delivered: declaredIncomes.filter(
        income => (income.documents?.length ?? 0) > 0,
      ).length,
    },
  };
};
